import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bf5b181"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }
const _hoisted_2 = {
  key: 0,
  class: "eyebrow"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.eyebrow)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.eyebrow), 1))
      : _createCommentVNode("", true),
    _createElementVNode("header", _mergeProps({ style: { 'text-align': _ctx.textAlign } as any }, { innerHTML: _ctx.header }), null, 16, _hoisted_3),
    _createElementVNode("div", _mergeProps({ style: { 'text-align': _ctx.textAlign } as any }, { innerHTML: _ctx.content }), null, 16, _hoisted_4)
  ]))
}